import { render, staticRenderFns } from "./customer-project.vue?vue&type=template&id=4703c096"
import script from "./customer-project.vue?vue&type=script&lang=js"
export * from "./customer-project.vue?vue&type=script&lang=js"
import style0 from "./customer-project.vue?vue&type=style&index=0&id=4703c096&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports